import React from "react";
import { Link } from 'react-router-dom';
import './ContentAvisoLegal.css'

export const ContentAvisoLegal = () => {
    return(
        <div className="legal-advise-content">
            <div>
                <h1>CONDICIONES DE USO Y CONTRATACIÓN</h1>
                <p><em>Última actualización: 10 de octubre de 2025</em></p>
                <br/>

                <h2>1.- TITULARIDAD</h2>
                <br/>
                <p>
                    El titular de esta web y responsable del tratamiento de esta web es ADI & SALU TIC SL. (en adelante el "Servicio"), con domicilio en Plaza Vicente Aleixandre Campos, 208
Boecillo (47151), Valladolid, España.
                </p>
                <p>
                    <strong>Correo electrónico:</strong>{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                    <br/>
                    <strong>NIF:</strong> B44847127
                </p>
                <p>
                    ADI & SALU TIC SL. está inscrita en el Registro Mercantil de Badajoz, Tomo 356, folio 22, sección 8, inscripción I/A2 y con hoja H BA 16895.
                </p>
                <p>
                    El uso de la web atribuye la condición de usuario, y con ello aceptas los términos y condiciones de nuestro Servicio.
                </p>
                <br/>

                <h2>2.- ACEPTACIÓN</h2>
                <br/>
                <p>
                    El Servicio está disponible para cualquier usuario, particular o profesional, para su consumo propio y sujeta a los siguientes términos y condiciones: estas Condiciones de Uso y Contratación, nuestra{' '}
                    <Link to="/politica-privacidad" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                        Política de Privacidad
                    </Link>
                    {' '}y{' '}
                    <Link to="/politica-cookies" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                        Política de Cookies
                    </Link>
                    , que además estarán siempre disponibles en el pie del sitio online y no deberá ser utilizado con fines ilícitos ni en modo distinto a lo contemplado en las mismas.
                </p>
                <p>
                    Por otro lado, te informamos que por motivos legales archivamos los documentos electrónicos en que quedan formalizadas las compras en tu perfil. Podrás acceder a dichos documentos en cualquier momento en tu cuenta o solicitándolo en:{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                </p>
                <p>
                    En ese sentido, como usuario del Servicio, ya sea de un tipo u otro, aceptas recibir electrónicamente las facturas de tus compras. En todo caso, siempre que lo solicites se te hará llegar la factura en formato papel en la dirección que nos indiques. Para más información, contacta con nosotros en:{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                </p>
                <br/>

                <h2>3.- DESCRIPCIÓN Y USO DEL SERVICIO</h2>
                <br/>
                
                <h3>3.1.- Prestación</h3>
                <p>
                    CUIDATIA es una plataforma que conecta a personas mayores, familias, profesionales y administraciones con los mejores servicios sanitarios y sociosanitarios online, adaptados a cada necesidad y territorio.
                </p>
                <p>
                    A través del Servicio puedes darte de alta como profesional que ofrezca sus servicios o como cliente en busca de servicios sanitarios y sociosanitarios.
                </p>
                <p>
                    Si usas el Servicio como profesional deberás crear tu perfil desde el botón "Soy Profesional" y completar la información solicitada. Si usas el Servicio como potencial usuario deberás crear tu perfil desde el botón "Soy Cliente", completar la información solicitada y una vez dentro buscar y contactar con el profesional que te pudiera interesar.
                </p>

                <h3>3.2.- Uso</h3>
                <p>
                    Los usuarios, ya sean potenciales clientes o profesionales, se comprometen a usar el Servicio de acuerdo a la legislación vigente y los términos y condiciones de la plataforma. Igualmente, los usuarios se comprometen a no recabar datos con finalidad publicitaria, remitir publicidad de cualquier clase o comunicaciones con fines de venta u otras de naturaleza comercial. Tampoco podrá poner a disposición de terceros, con cualquier finalidad, datos recabados en el Servicio.
                </p>
                <p>
                    En caso de incumplir estas obligaciones, los usuarios deberán responder frente a aquéllos. De igual forma en caso de dañar, inutilizar, sobrecargar, deteriorar o impedir la normal utilización de los materiales e información contenidos en el Servicio, los sistemas de información o los documentos, archivos y toda clase de contenidos almacenados en cualquier equipo informático del Servicio, de sus miembros o de cualquier usuario del Servicio.
                </p>
                <br/>

                <h2>4.- ENLACES EXTERNOS</h2>
                <br/>
                <p>
                    Puede que desde el Servicio se te remita a otros sitios web a través de enlaces.
                </p>
                <p>
                    Sin embargo, el Servicio no tiene ningún control sobre esos sitios o su contenido, sujetos a sus propios términos y condiciones. Por tanto, el Servicio no es responsable de la calidad, veracidad o exactitud de la información contenida en aquellos.
                </p>
                <br/>

                <h2>5.- EDAD</h2>
                <br/>
                <p>
                    En cuanto al registro en nuestro Servicio, o la contratación de alguna de nuestras suscripciones de pago, declaras que eres mayor de edad y que dispones de la capacidad legal necesaria para vincularte por este acuerdo y utilizar el sitio de conformidad con sus términos y condiciones, que comprendes y reconoces en su totalidad.
                </p>
                <p>
                    Si contratas en nombre de una empresa el Servicio, reconoces disponer de autorización y la representación adecuada en nombre de la organización para ello.
                </p>
                <p>
                    Declaras que toda la información que proporciones para acceder al Servicio, antes y durante su utilización, es verdadera, completa y precisa.
                </p>
                <br/>

                <h2>6.- PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
                <br/>
                
                <h3>6.1.- Contenido propio</h3>
                <p>
                    El contenido y la información del Servicio (entre otros datos, texto, sonido, vídeo, imagen o código informático), así como la infraestructura utilizada para proporcionar tal contenido e información, es propiedad del Servicio o bien dispone de las autorizaciones correspondientes para su uso.
                </p>
                <p>
                    Además, no se cede a ninguno de los usuarios ningún derecho de propiedad intelectual o industrial sobre el sitio web ni sobre ninguno de sus elementos integrantes, quedando expresamente prohibida la reproducción, transformación, distribución, comunicación pública, puesta a disposición, extracción, reutilización, reenvío o la utilización de cualquier naturaleza, por cualquier medio o procedimiento, de cualquiera de ellos, salvo en los casos en que esté legalmente permitido o sea autorizado por el titular de los correspondientes derechos.
                </p>
                <p>
                    Para cualquier otro uso del contenido del Servicio necesitas nuestro consentimiento previo por escrito.
                </p>

                <h3>6.2.- Contenido de usuario</h3>
                <p>
                    Como usuario, de un tipo u otro, puedes contribuir al Servicio de diversas maneras, tales como enviar correos electrónicos, sugerencias, mensajes, video presentación, tarjeta digital o reseñas, entre otros (en adelante "Contenido").
                </p>
                <p>
                    Podemos usar ese Contenido de distintas maneras, por ejemplo mostrarlo en el sitio web, reformatearlo, traducirlo a otros idiomas, editarlo para aportar claridad, corregir errores, crear obras derivadas a partir de él, promocionarlo y distribuirlo.
                </p>
                <p>
                    Por tanto, el Contenido sigue siendo de tu propiedad pero al enviarlo concedes al Servicio una licencia de uso mundial, no exclusiva, gratuita, hasta la retirada del contenido, transferible y sublicenciable sobre ese Contenido.
                </p>
                <p>
                    No obstante, el Servicio se reserva el derecho de no publicar aquellos contenidos o informaciones que sean falsas o contrarias a los derechos de terceros.
                </p>

                <h3>6.3.- Para profesionales</h3>
                <p>
                    Como Profesional, en caso de disponer de cuenta habilitada en la plataforma:
                </p>
                <ul>
                    <li>Debes mantener un perfil en el Servicio que cuente con información de contacto del servicio de atención al cliente, incluido uno o más de los siguientes datos: dirección de correo electrónico, teléfono y/o nombre de la empresa. Asegúrate de que la información sea precisa y esté actualizada. No debes hacerte pasar por otra empresa ni, de otro modo, engañar a los Clientes en cuanto a la naturaleza de tu negocio.</li>
                    <li>No debes ponerte en contacto por medios ajenos a los habilitados en la plataforma con Clientes, salvo que ellos te hayan contactado a través de otros medios. Así mismo no puedes confundir, engañar, defraudar, inducir a error, ni envíar spam.</li>
                    <li>Debes respetar todas las solicitudes (tanto dentro como fuera del Servicio) que las personas envíen para bloquear, interrumpir o, de otro modo, darse de baja de las comunicaciones que les envías a través del Servicio, incluyendo eliminar a esa persona de tu lista de contactos.</li>
                </ul>

                <h3>6.4.- Actividades prohibidas</h3>
                <p>
                    Te comprometes a no realizar ninguno de los actos siguientes:
                </p>
                <ul>
                    <li>a) Acceder, supervisar o copiar contenido o información de este sitio web mediante el uso de robots, rastreadores, raspadores de datos o cualquier otro medio automatizado que permitan acceder, rastrear, indexar, recuperar o utilizar de cualquier otro modo el sitio web o su contenido para cualquier propósito sin el permiso explícito por escrito del Servicio;</li>
                    <li>b) Insertar, reflejar o incorporar de algún otro modo una parte de este sitio web en otro sin nuestra autorización previa por escrito;</li>
                    <li>c) Intentar modificar, traducir, adaptar, editar, descompilar, desensamblar o aplicar ingeniería inversa a ningún programa de software que el Servicio utilice en relación con el sitio web;</li>
                    <li>d) Usar el sitio web para amenazar, acosar, defraudar, incitar, hostigar a otras personas o defender el hostigamiento de otra persona, o interferir de cualquier otro modo con el uso del sitio web por parte de otro usuario; </li>
                    <li>e) Usar el sitio web para enviar o transmitir correo no deseado (“spam”), cadenas de mensaje, concursos, “correo basura”, sistemas piramidales, encuestas u otros mensajes masivos, ya sean de naturaleza comercial o no;</li>
                    <li>f) Utilizar el sitio web para infringir derechos de terceros, lo que incluye el quebrantamiento de la confianza y la infracción de copyright, marcas comerciales, patentes, secretos comerciales, derechos morales, derechos de privacidad o cualesquiera otros derechos de propiedad intelectual o de propiedad;</li>
                    <li>g) Intentar obtener acceso no autorizado al sitio web, los sistemas informáticos o las redes conectadas al sitio web mediante prácticas de piratería informática, extracción de contraseñas o cualquier otro medio. Así como la transmisión de virus informáticos, gusanos, defectos, troyanos u otros elementos de naturaleza destructiva;</li>
                    <li>h) Utilizar algún dispositivo, software o rutina que interfiera con el funcionamiento correcto y las medidas de seguridad del sitio web; </li>

                </ul>

                <h3>6.5.- Espacios de opinión y contenido de la plataforma</h3>

                <p>
                    El Servicio proporciona áreas de opinión que están también sujetas a estas Condiciones de Uso y Contratación. 
                </p>

                <p>
                    Como usuario del Servicio serás el único responsable del uso que hagas de ellas y las utilizarás por tu cuenta y riesgo. El Servicio no editará ni controlará los mensajes de los usuarios publicados o distribuidos en el sitio web ni asumirá responsabilidad ni obligación alguna por dichos mensajes de los usuarios, más allá de lo previsto legalmente.
                </p>
                <p>
                    No obstante, el Servicio se reserva el derecho de eliminar los mensajes y el contenido de los usuarios. En esas áreas de debate o reseña, no podrás publicar ningún contenido que sea: falso, ilegal, engañoso, injurioso, difamatorio, obsceno, pornográfico, indecente, acosador, intimidatorio, contrario a los derechos de privacidad o publicidad, abusivo o fraudulento.
                </p>
                <p>
                    Como usuario del Servicio manifiestas que eres el propietario o que posees los permisos necesarios para usar y autorizar el uso del contenido compartido en el Servicio conforme a lo descrito, especialmente en el caso de los usuarios Profesionales y el contenido, material, bienes o servicios que promocionan a través de la plataforma.
                </p>
                <p>
                    En todo caso, recuerda que al acceder o usar el Servicio podrás verte expuesto a contenido de otros usuarios que podría ser ofensivo, obsceno, impreciso, censurable o inadecuado por cualquier otra razón. El Servicio no suscribe dicho contenido ni puede refrendar su precisión.
                </p>
                <p>
                    No obstante, el Servicio se reserva el derecho de no publicar aquellos contenidos o informaciones que sean falsas o contrarias a los derechos de terceros, así como habilitar un canal de réplica apropiado.
                </p>
                <br/>

                <h2>7.- PRECIO E IMPUESTOS</h2>
                <br/>
                
                <h3>7.1.- Como Cliente</h3>
                <p>
                    El uso del Servicio es gratuito, pero puede comportar cargos para ti por los servicios que contrates de un Profesional.
                </p>

                <h3>7.2.- Como Profesional</h3>
                <p>
                    El precio del plan contratado por el Profesional deberá abonarse al Servicio en el momento de realizar el alta y contratación.
                </p>
                <p>
                    Los cargos incluirán los impuestos aplicables cuando se requiera por ley, serán definitivos y no reembolsables salvo que en estas condiciones se disponga lo contrario.
                </p>
                <p>
                    El Servicio emitirá la correspondiente factura por el plan adquirido.
                </p>
                <p>
                    Para cualquier aclaración, incidencia o reclamación, puedes contactar con nosotros al siguiente email:{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                </p>
                <p>
                    El Servicio, en cualquier momento y en caso de detectar errores, modificaciones, nulidades o cancelaciones o cualquier otra circunstancia que lo permita, se reserva el derecho de establecer, eliminar y/o revisar los cargos para alguno o todos los servicios contratados.
                </p>
                <br/>

                <h2>8.- RESTRICCIÓN, SUSPENSIÓN Y TERMINACIÓN DEL SERVICIO</h2>
                <br/>
                <p>
                    Si como Profesional infringes los términos de las presentes condiciones legales o en el periodo de 6 meses tu valoración por parte de los clientes no alcanza los mínimos propios del sector (inferior a 3 estrellas en valoración global), el Servicio podrá restringir, suspender o terminar tu servicio de intermediación. En tales casos:
                </p>
                <ul>
                    <li>a) Si se restringe o suspende tu actividad, se te notificará de manera motivada a tu correo electrónico antes de que surta efecto.</li>
                    <li>b) Si se decide terminar completamente la prestación de todos tus servicios se te proporcionará, al menos treinta días antes de que la terminación surta efecto, una declaración de los motivos que justifiquen la decisión mediante correo electrónico, salvo obligación legal o necesidad imperiosa de terminar el servicio de manera inmediata.</li>
                </ul>
                <p>
                    En todo caso, se te ofrecerá la oportunidad de aclarar los hechos y circunstancias en el marco de un procedimiento interno de tramitación de controversias.
                </p>
                <br/>

                <h2>9.- PAGO Y MEDIOS</h2>
                <br/>
                <p>
                    Para contratar una suscripción, es imprescindible abonarla en su totalidad y por adelantado.
                 </p>
                <p>   
                     El pago del Servicio contratado se podrá realizar:
                </p>
                <ul>
                    <li>Mediante tarjeta de crédito o débito VISA o MasterCard, cargándose el importe en el momento de la compra de los productos.</li>
    
                </ul>
                            <p>   
                     En este sentido, el Servicio informa a los titulares de las tarjetas de crédito y débito que las transacciones en la tienda online se realizan en una pasarela de pago segura, utilizándose la tecnología TLS para garantizar la seguridad en la transmisión de los datos.
                </p>
                <br/>

                <h2>10.- VALIDEZ DE LAS OFERTAS</h2>
                <br/>
                <p>
                    Los planes ofertados en el Servicio, y los precios de éstos, estarán disponibles para su adquisición mientras se encuentren en el catálogo visualizado por medio de la web.
                </p>
                <p>
                     En todo caso, el Servicio se reserva el derecho de efectuar en el mismo las modificaciones que considere oportunas, pudiendo actualizar funciones del Servicio o características del plan ofertado según el mercado, así como las funciones propias del Club al que dan acceso los planes.
                </p>
                <p>
                      Los precios que aparecen en la web son orientativos e indicados por los usuarios profesionales, de este modo, podrían variar sin previo aviso.
                </p>
                <p>
                    Te informamos que a pesar de las actualizaciones que se realizan a los precios del Servicio, éstos podrían contener errores. Corregiremos con prontitud todos los errores que aparezcan y que nos afecten, pero no serán vinculantes con el Servicio.
                </p>
                <br/>

                <h2>11.- CUALIFICACIÓN DE LOS PROFESIONALES</h2>
                <br/>
                <p>
                    El Servicio no intervendrá en ningún caso en las negociaciones llevadas a cabo entre un potencial Cliente y un Profesional, permaneciendo al margen de las mismas en todo momento, por lo que no será responsable, en ningún caso, del cumplimiento de las obligaciones de uno con otro.
                </p>
                <p>    
                    Por tanto, potenciales Clientes y Profesionales eximen al Servicio de cualquier desavenencia que pudiera surgir entre ambos.
                </p>    
                <p>
                     Es responsabilidad exclusiva del Cliente o potencial Cliente la comprobación de la idoneidad de los servicios ofrecidos por el Profesional, y que los mismos se adapten a sus necesidades. El Cliente o potencial Cliente asume asimismo la responsabilidad de examinar la titulación, capacitación y competencia del Profesional, así como de realizar el oportuno seguimiento sobre los servicios requeridos, los ejercicios indicados, los recursos proporcionados y la adecuación a lo solicitado por el Cliente o potencial Cliente y acordado entre las partes.
                </p>
                <p>
                    El Servicio procura que los Profesionales adheridos cuenten con cédula profesional vigente y estén homologados por la Administración Pública. Sin embargo, no puede garantizar tal hecho, eximiéndose de responsabilidad en caso de incumplimiento por parte del Profesional.
                </p>
                <p>   
                     En ningún caso el Servicio controlará ni intervendrá en la ejecución de las tareas y servicios por el Profesional, ni en la adecuación, calidad o resultado de las mismas, ni en las obligaciones de pago derivadas de ellas. Por ello, el Servicio excluye, con toda la extensión permitida por el ordenamiento jurídico, cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la ejecución o resultado del trabajo encomendado al Profesional. 
                </p>
                <p> 
                     A su vez, el Cliente o potencial Cliente expresamente exime al Servicio de cualquier discrepancia, responsabilidad, daño, perjuicio o menoscabo como resultado de la contratación o del trabajo realizado por el profesional.
                </p>
                <br/>

                <h2>12.- CLASIFICACIÓN, TRATO DIFERENCIADO Y ACCESO A DATOS DE LOS PROVEEDORES</h2>
                <br/>
                
                <h3>12.1.- Clasificación</h3>
                <p>
                    El Servicio utiliza sistemas de clasificación, valoración y/o ponderación a fin de determinar la prioridad en el posicionamiento dentro de la web de un servicio frente a otro.
                </p>
                <p>
                    En concreto, nuestro sistema de clasificación tiene en cuenta:
                </p>
                <ul>
                    <li>a) Las características de los servicios contratados, por ejemplo en función del plan adquirido por el Profesional.</li>
                    <li>b) La ubicación física del Profesional para determinar una clasificación por ubicación dentro de la categoría elegida.</li>
                    <li>c) La valoración del servicio por los Clientes a fin de establecer una clasificación por posicionamiento vertical, pudiendo ser alteradas dichas clasificaciones por medio de remuneración directa o indirecta en función del plan adquirido por el Profesional, en cuyo caso así se hará constar.</li>
                </ul>
                <p>
                    Así mismo, el Servicio informa de que el mismo permite o podría permitir realizar clasificaciones basadas en filtros elegidos por el usuario (localización u orden alfabético, por ejemplo) que en caso de ser utilizados dejarán sin efecto el sistema de clasificación inicialmente adoptado por el Servicio.
                </p>

                <h3>12.2.- Trato diferenciado</h3>
                <p>
                    El Servicio puede adoptar medidas específicas que permitan aplicar diferencias de trato sobre Profesionales que presten los mismos productos o servicios. En concreto, estas diferencias de trato estarán basadas en remuneraciones directas o indirectas o en un distinto nivel de acceso a datos de los Clientes, en función del plan adquirido. En tales casos, la clasificación y/o posicionamiento del Profesional podría verse alterada dentro de plataforma, haciéndose constar en lugar visible que esa posición o clasificación se encuentra "patrocinada", "recomendada" o término equivalente.
                </p>

                <h3>12.3.- Acceso a datos</h3>
                <ul>
                    <li>a) El Servicio tiene acceso a los datos del Profesional o a los datos que se vayan generando, incluyendo en qué condiciones y a qué categorías de datos.</li>
                    <li>b) Los Profesionales podrán, en caso de que así lo contraten, tener acceso a los datos de los clientes o usuarios (aunque sea de manera agregada) que usen el Servicio, incluyendo en qué condiciones y a qué categorías de datos.</li>
                    <li>c) No se facilitan datos a terceros que no sean indispensables para el correcto funcionamiento del Servicio.</li>
                </ul>
                <br/>

                <h2>13.- EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD</h2>
                <br/>
                <p>
                    Salvo en aquellos casos expresamente descritos en los presentes términos y condiciones y hasta donde la ley permita, el Servicio no se responsabiliza por los daños y perjuicios de cualquier naturaleza que puedan deberse a la falta de exactitud, exhaustividad o actualidad, incluidos errores y omisiones, de la información contenida en el Servicio. De igual forma, tampoco de cualquier deber o compromiso de verificar o vigilar sus contenidos e informaciones. Igualmente, el Servicio no garantiza la disponibilidad y continuidad del funcionamiento del mismo. El Servicio procurará advertir con suficiente antelación de las interrupciones que pudieran suceder en el funcionamiento del Servicio siempre que ello sea posible.
                </p>
                <p>
                    El Servicio excluye, con toda la extensión permitida por el ordenamiento jurídico, cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la falta de disponibilidad o de continuidad del funcionamiento del Servicio. De igual manera, respecto a la defraudación de la utilidad que los usuarios hubiesen podido atribuir al Servicio. Asimismo, el Servicio excluye cualquier responsabilidad por los daños y perjuicios de toda naturaleza que pudieran deberse a la utilización del Servicio y de sus contenidos por parte de los usuarios, Clientes o Profesionales, o que puedan deberse a la falta de veracidad, vigencia o autenticidad de la información que los usuarios proporcionan a otros acerca de sí mismos.
                </p>
                <p>
                    En particular, el Servicio excluye cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la suplantación de la personalidad de un tercero efectuada por un usuario en cualquier clase de comunicación realizada a través del Servicio.
                </p>

                <h3>13.2.- Responsabilidad respecto a los Profesionales</h3>
                <p>
                    Si alguien presenta una reclamación contra el Servicio relacionada con las acciones del Profesional, su información o contenido en el Servicio, el mismo indemnizará y eximirá de responsabilidad, en la medida en que la ley lo permita, al Servicio por cualquier tipo de obligación, daño, pérdida y gasto (incluidos los costos y honorarios legales razonables) que surjan en relación o se vinculen de algún modo con lo siguiente:
                </p>
                <ul>
                    <li>a) Tu acceso a nuestro Servicio o el uso que hagas de estos, incluida la información proporcionada en relación con ellos;</li>
                    <li>b) El incumplimiento por tu parte de nuestras condiciones, del servicio que debía proporcionarse o de la ley aplicable; o</li>
                    <li>c) Cualquier declaración falsa que tú realices.</li>
                </ul>
                <p>
                    Colaborarás en la medida en que te lo solicitemos en la defensa o resolución de cualquier reclamación.
                </p>
                <p>
                    Si las leyes de tu país de residencia, aplicables como resultado del uso que hagas de nuestros servicios, no lo permiten, las limitaciones anteriores no modificarán tus derechos con respecto al Servicio.
                </p>
                <br/>

                <h2>14.- DESISTIMIENTO, CANCELACIÓN Y REEMBOLSOS</h2>
                <br/>
                <p>
                    El Profesional no podrá desistir del plan contratado con el Servicio al contratarlo como empresario individual y no como consumidor.
                </p>
                <p>
                    En todo caso, podrá cancelarlo en cualquier momento si bien no habrá reembolsos ni totales ni parciales.
                </p>
                <p>  
                 En caso de duda, contacta con nosotros en:{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                </p>
                <br/>

                <h2>15.- ELIMINAR CUENTA</h2>
                <br/>
                <p>
                    Ya sea como Profesional o Cliente, puedes cancelar tu cuenta con el Servicio en cualquier momento desde la configuración de la misma o enviándonos un correo electrónico a{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                </p>
                <p>
                    Si un Cliente o Profesional se da de baja guardaremos su información de acuerdo a lo establecido en la Política de Privacidad.
                </p>
                <br/>

                <h2>16.- MODIFICACIONES Y NULIDAD</h2>
                <br/>
                <p>
                    Podremos actualizar los términos y condiciones del Servicio en el futuro, así como características y funciones del propio Servicio. Sin embargo, esto no afectará negativamente la calidad de ningún servicio específico que hayamos acordado expresamente proporcionar. 
                </p>
                <p>
                    Te informaremos sobre los cambios en términos y condiciones colocando un aviso en un lugar prominente de nuestro sitio web y/o por correo electrónico.
                </p>
                <p> 
                     Si cualquier cláusula incluida en nuestros términos y condiciones fuese declarada, total o parcialmente, nula o ineficaz, la misma solo afectará a dicha disposición o a la parte de la misma que resulte nula o ineficaz. Subsistirán los términos y condiciones en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.
                </p>
                <br/>

                <h2>17.- COOKIES</h2>
                <br/>
                <p>
                    Consulta nuestra Política de Cookies para conocer el uso que hacemos de ellas.
                </p>
                <br/>

                <h2>18.- MEDIDAS DE SEGURIDAD</h2>
                <br/>
                <p>
                    El Servicio adopta todas las medidas técnicas y organizativas necesarias para proteger la seguridad e integridad de la información personal y no personal recopilada. Tanto frente a accesos no autorizados como su alteración, pérdida o destrucción accidentales.
                </p>
                <p>
                    En todo caso, el Servicio no puede garantizar la seguridad absoluta de la información recopilada, por lo que debes colaborar y utilizar en todo momento el sentido común sobre la información compartida.
                </p>
                <p>
                    Entiendes y reconoces que, incluso después de su eliminación, la información personal y no personal puede permanecer visible en caché o si otros usuarios la han copiado o almacenado.
                </p>
                <br/>

                <h2>19.- CONTACTO</h2>
                <br/>
                <p>
                    Si tienes dudas sobre estas condiciones de uso y privacidad, contacta con nosotros en:
                </p>
                <p>
                    <strong>E-mail:</strong>{' '}
                    <a
                        href="mailto:hola@adiper.es"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        hola@adiper.es
                    </a>
                    {' '}
                    <span style={{ marginLeft: 12, fontSize: 13 }}>
                        <a
                            href="https://mail.google.com/mail/?view=cm&fs=1&to=hola@adiper.es"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#0066cc', textDecoration: 'underline', marginRight: 10 }}
                        >
                            Abrir en Gmail
                        </a>
                        <a
                            href="https://outlook.live.com/owa/?path=/mail/action/compose&to=hola@adiper.es"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#0066cc', textDecoration: 'underline' }}
                        >
                            Abrir en Outlook
                        </a>
                    </span>
                    <br/>
                    <strong>Dirección:</strong> C/ Hornachos, 8, CP 06200, Almendralejo, Badajoz, España
                </p>
                <br/>
            </div>
        </div>
    )
}